var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.schema)?_c('t-action-form',{attrs:{"schema":_vm.schema,"value":_vm.selectedNode,"type":_vm.selectedNodeType,"startupTypes":_vm.startupTypes},on:{"abort":_vm.handleAbortEdit,"delete":_vm.handleDeleteNode,"input":_vm.handleChangeNode}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }